import ReadResourceWarning from './ReadResourceWarning';
export default ReadResourceWarning;
